import NightSky from './NightSky';

export default NightSky;
